import { render } from "./Topbar.vue?vue&type=template&id=72e889d8"
import script from "./Topbar.vue?vue&type=script&lang=js"
export * from "./Topbar.vue?vue&type=script&lang=js"

import "./Topbar.vue?vue&type=style&index=0&id=72e889d8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__